export default __webpack_public_path__ + "static/media/MindsetVideos.b8b419da.jpg";